import posthog from 'posthog-js';

function posthogConfigured() {
  return Boolean(import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN);
}

export function resetPosthogSession() {
  if (!posthogConfigured()) return;
  try {
    posthog.reset();
  } catch (_) {
    /* ignore */
  }
}

/** Call after /auth/me returns a user (PostHogProvider must have initialized). */
export function identifyPosthogUser(user) {
  if (!posthogConfigured() || !user) return;
  const distinctId = String(user.id ?? user.userId ?? '').trim();
  if (!distinctId) return;
  const props = {};
  if (user.email) props.email = user.email;
  if (user.role) props.role = user.role;
  const oid = user.org_id ?? user.orgId;
  if (oid != null && oid !== '') props.org_id = String(oid);
  try {
    posthog.identify(distinctId, props);
  } catch (_) {
    /* ignore */
  }
}
